import React from 'react'

export default function CustomInput({ isEditable, onChange, onKeyDown, value, placeholder }) {

    return (
        <>
            {isEditable && (
                <h6 className="m-0 font-satoshi font-[700] text-[14px] text-[#000000] truncate">{value}</h6>
            )}

            {!isEditable && (
                <input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    className="font-[400] outline-none w-full font-satoshi text-[17px] text-[#515151] h-[24px] leading-[24px] p-0 m-0 overflow-hidden text-ellipsis whitespace-nowrap"
                    placeholder={placeholder}
                />
            )}
        </>
    )
}
